'use client'
import { getGameImageURL, useModalLink } from '@l2p/apps-shared'
import { useClickGame, useClickGameDemo } from '@l2p/common-hooks'
import { useConfig, useIsAuthorized } from '@l2p/swr-hooks'
import { useLocale } from 'next-intl'
import React from 'react'
import AddFavoriteIcon from '../../AddFavoriteIcon'
import Image from '../../Image'
import PlayForFunBtn from '../PlayForFunBtn'
import PlayNowBtn from '../PlayNowBtn'
import { DesktopGameCardProps } from '../types'
import styles from './styles.module.scss'

const DesktopGameCard: React.FC<DesktopGameCardProps> = ({
  title,
  withDemo,
  hasPlayNowIcon,
  hasFavorite = true,
  gameId,
  className = 'game-card',
  titleClassName = '',
  playNowBtnClassName = '',
  playDemoBtnClassName = '',
  clickEvent = () => {},
  gameCardPlaceholder,
  signUpModalKey,
  imageLoading,
  slug,
}) => {
  const globalConfig = useConfig()
  const { onClickDemo } = useClickGameDemo()
  const { onClickPlay } = useClickGame()
  const isAuth = useIsAuthorized()
  const lang = useLocale()
  const signUpUrl = useModalLink(signUpModalKey)

  return (
    <div className={`${styles.gameWrapper} ${className ? className : ''}`}>
      <div className={`${styles.backgroundMask} backgroundMask`} />
      <div className={`${styles.gameCover} gameCover`}>
        <Image
          objectFit={globalConfig?.gameCardImageBack ? 'contain' : undefined}
          src={getGameImageURL(gameId)}
          alt={title}
          placeholder={gameCardPlaceholder}
          rootMargin="0px"
          loading={imageLoading}
        />
      </div>
      <div className={`${styles.gameHoverItem} gameHoverItem`}>
        <div>
          <div className={`${styles.gameTitle} ${titleClassName}`}>{title}</div>
          {hasFavorite && (
            <div className={styles.addFavoritesWrapper}>
              <AddFavoriteIcon
                gameId={gameId}
                withBackground={false}
                withAnimation={true}
                image="/img/star.svg"
                imageFill="/img/full-star.svg"
              />
            </div>
          )}

          <div
            className={styles.playNowButtonWrapper}
            onClick={() => {
              clickEvent()
              onClickPlay(isAuth ? `/${lang}/game/${slug}` : signUpUrl)
            }}
          >
            <PlayNowBtn
              className={playNowBtnClassName}
              hasIcon={hasPlayNowIcon}
              typeButton="desktop"
            />
          </div>

          {withDemo && (
            <div
              onClick={() => {
                clickEvent()
                onClickDemo(`/${lang}/game/${slug}?demo=true`)
              }}
              className={styles.playFunButtonWrapper}
            >
              <PlayForFunBtn className={playDemoBtnClassName} />
            </div>
          )}
        </div>
      </div>
      {globalConfig?.gameCardImageBack && (
        <div className={styles.gameBlueCover}>
          <Image src={getGameImageURL(gameId)} alt={title} />
        </div>
      )}
    </div>
  )
}

export default React.memo(DesktopGameCard)
